// extracted by mini-css-extract-plugin
module.exports = {"buttonLabel":"_2r2s3"};